import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import _imports_0 from '../assets/page-image/bdtcl/缺陷检测.png';
const _hoisted_1 = {
  class: "bdtcl-wrapper"
};
const _hoisted_2 = {
  class: "bdtcl-page"
};
const _hoisted_3 = {
  class: "content-wrapper"
};
const _hoisted_4 = {
  class: "right-content"
};
const _hoisted_5 = {
  class: "section"
};
const _hoisted_6 = {
  class: "section"
};
const activeMenuId = 'bdtcl';
export default /*@__PURE__*/_defineComponent({
  __name: 'Bdtcl',
  setup(__props) {
    // 当前选中的菜单项
    return (_ctx, _cache) => {
      const _component_Breadcrumb = _resolveComponent("Breadcrumb");
      const _component_SideMenu = _resolveComponent("SideMenu");
      const _component_SectionTitle = _resolveComponent("SectionTitle");
      const _component_Footer = _resolveComponent("Footer");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Breadcrumb, {
        items: [{
          label: '首页',
          path: '/'
        }, {
          label: '产品服务'
        }, {
          label: '半导体量检测'
        }]
      }), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_SideMenu, {
        activeId: activeMenuId
      }), _createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("div", {
        class: "page-title"
      }, "晶圆有图形缺陷检测", -1)), _cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "publish-time"
      }, "发布时间：2025年1月1日", -1)), _cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "product-image"
      }, [_createElementVNode("img", {
        src: _imports_0,
        alt: "晶圆有图形缺陷检测"
      })], -1)), _createElementVNode("div", _hoisted_5, [_createVNode(_component_SectionTitle, {
        title: "产品介绍"
      }), _cache[0] || (_cache[0] = _createElementVNode("div", {
        class: "intro-content"
      }, [_createElementVNode("p", null, "该产品主要用于晶圆表面亚微米级缺陷高效检测,可精确识别各种微观缺陷并进行缺陷统计、分类和分析。产品可应用于半导体前道工序的质量控制,并拓展至芯片封装检测、芯片成品检测等工序流程。")], -1))]), _createElementVNode("div", _hoisted_6, [_createVNode(_component_SectionTitle, {
        title: "主要参数"
      }), _cache[1] || (_cache[1] = _createElementVNode("div", {
        class: "params-content"
      }, [_createElementVNode("div", {
        class: "params-title"
      }, "产品特点"), _createElementVNode("div", {
        class: "params-list"
      }, [_createElementVNode("p", null, "显微成像分辨率:200nm"), _createElementVNode("p", null, ">5 片/小时(300mm 晶圆"), _createElementVNode("p", null, "缺陷检出率>99.5%(直径>0.2um 缺陷)"), _createElementVNode("p", null, "可标记并统计晶圆表面的划痕、沾污、灰尘、粘连、缺失等缺陷及其分布情况"), _createElementVNode("p", null, "缺陷自动分类准确率>95%")])], -1))])])])]), _createVNode(_component_Footer)]);
    };
  }
});